import i18n from '../locales/index'
import { Message } from 'view-design';
export function validate (msg) {
  msg && Message.error(msg);
  return new Promise((resolve, reject) => {
    msg ? reject(msg) : resolve('')
  })
}
export function preferencesValuesValidate (vObj) {
  let msg = ''
  if (!vObj.inputValue) {
    msg = i18n.t('libs_validate_104');
  }
  if (vObj.values.indexOf(vObj.inputValue) > -1) {
    msg = i18n.t('libs_validate_105');
  }
  return validate(msg);
}
export function preferencesValidate (vObj) {
  let msg = ''
  if (!vObj.preName) {
    msg = i18n.t('libs_validate_106');
  }
  if (vObj.preValues.length === 0) {
    msg = i18n.t('libs_validate_104');
  }
  if (vObj.values.findIndex(item => item.name === vObj.preName) > -1) {
    msg = i18n.t('libs_validate_105');
  }
  return validate(msg);
}
